// resources/js/accordion-banner.js

export function initAccordionBanner(container) {
    const classPrefix = 'accordion-info';
    const dataPrefix  = 'data-accordion-info';

    const heads    = container.querySelectorAll(`[${dataPrefix}-accordion-item]`);
    const contents = container.querySelectorAll(`.${classPrefix}__accordion-content`);
    const imgs     = container.querySelectorAll(`[${dataPrefix}-image-accordion]`);

    const showImage = (key) => {
        imgs.forEach(img => {
            img.classList.toggle('is-visible',
                img.getAttribute(`${dataPrefix}-image-accordion`) === key
            );
        });
    };

    // Показываем главный
    showImage('0');

    heads.forEach(head => {
        head.addEventListener('click', () => {
            const key    = head.getAttribute(`${dataPrefix}-accordion-item`);
            const active = head.classList.contains('is-active');

            // Сброс
            heads.forEach(h => h.classList.remove('is-active'));
            contents.forEach(c => {
                c.classList.remove('is-open');
                c.style.maxHeight = null;
            });

            if (!active) {
                head.classList.add('is-active');
                const content = head.nextElementSibling;
                content.classList.add('is-open');
                content.style.maxHeight = content.scrollHeight + 'px';
                showImage(key);
            } else {
                showImage('0');
            }
        });
    });
}

document
    .querySelectorAll('[data-accordion-info]')
    .forEach(initAccordionBanner);
